import { useConfig } from '../ConfigProvider';

export default function PromoBanner({club}) {
    const config = useConfig();
    const url = club?.offer_url || config.offer_url;

    if (url) {
        return <div className='w-full justify-center items-center' style={{ display: "flex", justifyContent: 'center' }}>
            <img alt="Bannière On Air" src={url} style={{ paddingTop: '0.8rem', height: 'auto' }} className="w-full lg:w-[60%]" />
        </div>
    }

    return null;
}